import {useCallback} from 'react'

/**
 * A ref callback that calls "onSeen" each time the element it is put on scrolls into view, or
 * nothing without one. Kept the same while "onSeen" is, so the element is watched once rather than
 * afresh on every render.
 */
const useSeen = onSeen => useCallback(element => {
  if (!element || !onSeen || typeof IntersectionObserver === 'undefined') return

  const observer = new IntersectionObserver(entries => {
    if (entries.some(({isIntersecting}) => isIntersecting)) onSeen()
  })

  observer.observe(element)

  return () => observer.disconnect()
}, [onSeen])

export default useSeen
